import { watch } from 'vue';
import { CORPORATE_REQUEST_TIMEOUT_MS } from '@/services/corporatePayment';
import type { TeamCorporateState } from './types';

/** 对公建单期间停用扫码；关闭、切参、换团队会同步废弃本次响应。 */
export function beginCorporateOrder(state: TeamCorporateState) {
  // 清除仍可扫码的旧二维码；停止轮询后不能继续展示该订单。
  state.resetOrderInfo();
  const requestId = ++state.corporateOrderRequestId;
  state.corporateOrderLoading = true;
  const controller = new AbortController();
  let active = true;
  let timedOut = false;
  let rejectTimeout!: (error: Error) => void;
  const timeoutResult = new Promise<never>((_, reject) => { rejectTimeout = reject; });
  // 新支付弹窗同样属于请求宿主，关闭或切换支付类型后不能恢复旧对公订单。
  const stop = watch(() => [state.modalOpen, state.productModalIsOpen, state.teamMemberPayModalOpen, state.modalType,
    state.currentStep, JSON.stringify(state.formData), state.teamInfo?.teamId,
    state.userType, state.isUseCorporateTransfer], () => {
    active = false;
    controller.abort();
    finish();
  }, { flush: 'sync' });
  const timeout = setTimeout(() => {
    timedOut = true;
    controller.abort();
    rejectTimeout(new Error('CORPORATE_ORDER_TIMEOUT'));
  }, CORPORATE_REQUEST_TIMEOUT_MS);
  // 成功回调切换弹窗前必须释放监听，避免自身 UI 切换使有效结果失效。
  function finish() {
    stop();
    clearTimeout(timeout);
    if (requestId === state.corporateOrderRequestId) state.corporateOrderLoading = false;
  }
  return { signal: controller.signal, finish,
    wait: <T>(request: Promise<T>) => Promise.race([request, timeoutResult]),
    isActive: () => active && requestId === state.corporateOrderRequestId,
    isTimedOut: () => timedOut };
}
